import { render, staticRenderFns } from "./newsTool.html?vue&type=template&id=2b2feb54&scoped=true&"
import script from "./newsTool.js?vue&type=script&lang=js&"
export * from "./newsTool.js?vue&type=script&lang=js&"
import style0 from "./newsTool.scss?vue&type=style&index=0&id=2b2feb54&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=2b2feb54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2feb54",
  null
  
)

export default component.exports